import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface ConciergeModel extends BaseModel {
  variables?: { [key: string]: string } | ConciergeVariables;
}

export interface ConciergeVariables {
  ConciergeImage: string;
  ConciergeImageHref: string;
  ConciergeImageAlt: string;
  ConciergeHeading: string;
  ConciergeText: string;
  ConciergeImageHrefSegmentRegex:string;
}

export class ConciergeInitVariables implements ConciergeVariables {
  ConciergeImage = '';
  ConciergeImageHref = '';
  ConciergeImageAlt = '';
  ConciergeHeading = '';
  ConciergeText = '';
  ConciergeImageHrefSegmentRegex = '';
}

export class ConciergeInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ConciergeInitVariables();
    this.variables = {...initVars};
    this.notifications = [new NotificationInitVariables()];
  }
}
